<template>
  <div :class="['app-container', currentNavList[curIndex].isShowNav ? '' : 'no-top']">
    <van-nav-bar
      :title="currentNavList[curIndex].label"
      v-if="currentNavList[curIndex].isShowNav"
    />
    <keep-alive>
      <router-view />
    </keep-alive>
    <van-tabbar v-if="!isHideTabbarRoute" route style="z-index: 998;">
      <van-tabbar-item
        replace
        :to="'/' + item.path"
        v-for="(item, index) in currentNavList"
        :key="index"
      >
        <span>{{ item.label }}</span>
        <template #icon="props">
          <!-- <img
            :src="
              props.active
                ? require('@/assets/img/layout/nav1@2x-o.png')
                : require('@/assets/img/layout/nav1@2x.png')
            "
          /> -->
          <img :src="props.active ? item.active : item.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "layoutWrap",
  components: {},
  props: {},
  data() {
    return {
      // 静态控制变量：true显示学生导航，false显示普通导航
      isStudent: true,
      navList: [
        {
          label: "首页",
          active: require("@/assets/img/v1-1/icon-home-selected.png"),
          inactive: require("@/assets/img/v1-1/icon-home.png"),
          path: "home",
          isShowNav: false,
        },
        {
          label: "应用",
          active: require("@/assets/img/v1-1/icon-app-selected.png"),
          inactive: require("@/assets/img/v1-1/icon-app.png"),
          path: "apps",
          isShowNav: false,
        },
        {
          label: "资讯",
          active: require("@/assets/img/v1-1/icon-news-selected.png"),
          inactive: require("@/assets/img/v1-1/icon-news.png"),
          path: "news",
          isShowNav: false,
        },
        {
          label: "我的",
          active: require("@/assets/img/v1-1/icon-user-selected.png"),
          inactive: require("@/assets/img/v1-1/icon-user.png"),
          path: "my",
          isShowNav: false,
        },
      ],
      studentNavList: [
        {
          label: "首页",
          active: require("@/assets/img/v1-1/icon-home-selected.png"),
          inactive: require("@/assets/img/v1-1/icon-home.png"),
          path: "home",
          isShowNav: false,
        },
        {
          label: "精准学",
          active: require("@/assets/img/v1-1/icon-P-Learn-selected.png"),
          inactive: require("@/assets/img/v1-1/icon-P-Learn.png"),
          path: "preciseLearning",
          isShowNav: false,
        },
        {
          label: "同步课程",
          active: require("@/assets/img/v1-1/icon-sclass-selected.png"),
          inactive: require("@/assets/img/v1-1/icon-sclass.png"),
          path: "syncCourse",
          isShowNav: false,
        },
        {
          label: "我的",
          active: require("@/assets/img/v1-1/icon-user-selected.png"),
          inactive: require("@/assets/img/v1-1/icon-user.png"),
          path: "my",
          isShowNav: false,
        },
      ],
      curIndex: 0,
      path: "home",
      hideTabbarRoutes: ["map", "mapDetail"], // 隐藏tabbar的路由
    };
  },
  watch: {
    $route: {
      handler() {
        this.path = this.$route.path.split("/")[1];
        this.currentNavList.some((v, i) => {
          if (v.path == this.path) {
            this.curIndex = i;
            return true;
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 根据props参数返回当前应该显示的导航列表
    currentNavList() {
      if(this.roleName == '学生') {
        return this.studentNavList;
      } else {
        return this.navList;
      }
    },
    isHideTabbarRoute() {
      return this.hideTabbarRoutes.includes(this.path);
    },
    ...mapGetters(['roleName'])
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.app-container {
  background-color: #f1f8ff;
  padding-top: 0;
}
.no-top {
}
.app-container >>> .van-tabs__line {
  background-color: #3c8ef2;
  width: 15px;
  height: 3px;
  border-radius: 0;
}
.app-container >>> .van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 20;
}
</style>
